import { Story } from '../../types/story';

export const berlinBackstage: Story = {
  id: 'berlin-backstage',
  title: 'Backstage Pass',
  excerpt: 'A groupie in Berlin gets more than she bargained for when the band invites her backstage after the show.',
  city: 'Berlin',
  publishDate: '2025-12-09',
  readTime: '28 min read',
  tags: ['♀♂', 'groupie', 'band', 'intense'],
  categories: ['forbidden', 'intense', 'adventurous'],
  intensity: 3,
  content: `The venue in Kreuzberg was packed, bodies pressed together in the darkness, the bass so loud I could feel it in my chest. I'd been following the band for three cities now—Prague, Dresden, and finally Berlin. They were on the edge of breaking big, still playing these sweaty underground clubs but with a buzz that said it wouldn't last much longer.

I wasn't the only one following them. There was a whole crew of us—mostly girls, mostly young, all hoping to catch the band's attention. Groupies, though we didn't call ourselves that. Fans. Believers. People who understood that the music was just the beginning.

But I was different. I'd caught Kai's eye in Prague, held it during an entire song while he sang directly to me. In Dresden, he'd pointed at me during the encore, made sure I knew he saw me. Tonight, in Berlin, I was determined to make it backstage.

I wore my tightest black jeans, a crop top that showed just enough, and boots that made my legs look endless. I pushed my way to the front and stayed there for the entire set, singing every word, dancing, making sure he couldn't look anywhere else.

It worked.

After the show, as the crowd filed out into the cold Berlin night, a guy with a clipboard appeared beside me. "You. The band wants to see you. Come with me."

My heart hammered as I followed him through a side door, down a narrow hallway that smelled like beer and cigarettes, to a room at the back of the venue. He knocked twice and pushed the door open.

The band was sprawled across beat-up couches, still sweaty from the show, passing around a bottle of whisky. Kai looked up when I walked in, and his face broke into a grin.

"You made it. I was hoping you would."

There were four of them. Kai on vocals and guitar, Max on bass, Felix on drums, and Jonas on lead guitar. I'd studied them all online, knew their names, their histories. I knew Kai had a girlfriend back in Hamburg. I knew Max had just gotten out of rehab. I knew Felix was the quiet one, and Jonas was the player who'd fucked half of Europe.

"Drink?" Kai offered me the bottle.

I took it, took a long pull, felt the burn. "Thanks."

"You've been following us," he said. Not a question.

"Yeah. The music is incredible."

"Just the music?" Jonas asked, grinning at me with that cocky smile I'd seen in a hundred photos.

I met his eyes. "Among other things."

They laughed, and I felt the energy in the room shift. This was a test. They wanted to see if I'd play along, if I was cool, if I was game for whatever came next.

"Sit," Kai said, patting the couch beside him.

I sat. He put his arm around me, casual but possessive. "What's your name?"

"Lena."

"Well, Lena. We're going to a party. Want to come?"

The party was in a loft in Friedrichshain, the kind of place that was probably a squat until recently. It was packed with the Berlin scene—musicians, artists, people who looked effortlessly cool in their thrifted clothes and undercuts. The band was treated like royalty, people making space for them, offering drinks and drugs and attention.

I stayed close to Kai, his arm around my waist, his hand occasionally drifting lower to squeeze my ass. We drank, we danced, we made out in a corner while people watched. I knew what this was—I wasn't naive. I was a trophy, a conquest, another groupie. But I didn't care. I wanted this. Wanted to be part of their world, even if just for one night.

"Come on," Kai said eventually, pulling me toward a back room. "Let's get some privacy."

The room was smaller, dimmer. There was a bed, a couch, some chairs. Max and Jonas followed us in, closing the door behind them. The music from the party was muffled now, just a bass thump through the walls.

"Where's Felix?" I asked.

"He doesn't do this," Max said, dropping onto the couch. "Too much of a romantic."

Kai pulled me onto the bed, kissing me hard. His hands were everywhere—in my hair, on my breasts, sliding up my thighs. I kissed him back, feeling the heat build, feeling the eyes of the other two on us.

"Is this okay?" Kai asked, pulling back to look at me. "All of us. Are you okay with that?"

I should have been scared. Should have said no, should have left. But I was drunk and high on adrenaline and the thrill of being wanted by three men who thousands of girls would kill to be with.

"Yes," I said. "I want this."

Kai grinned and pulled my top over my head. I wasn't wearing a bra—hadn't been all night—and his hands immediately went to my breasts, squeezing, his thumbs brushing over my nipples until they were hard. He leaned down and took one in his mouth, sucking hard, and I gasped.

Max and Jonas moved closer, watching. Then Max's hands were on me too, unbuttoning my jeans, sliding them down my hips. I lifted up so he could pull them off completely, leaving me in just my black panties.

"Fuck, you're hot," Jonas muttered, his eyes roaming over my body.

Kai kissed me again while Max hooked his fingers in my panties and pulled them down. I was completely naked now, spread out on the bed with three fully clothed men surrounding me. It should have made me feel vulnerable, but instead I felt powerful. They wanted me. All of them.

Max moved between my legs, spreading them wider. "Already so wet," he said, running a finger through my folds. I moaned, arching into his touch.

He didn't waste time. His mouth was on me, tongue licking and sucking, and I cried out. Kai was still working my breasts, alternating between them, while Jonas moved to kiss my neck, my shoulders, whispering dirty things in German that I didn't understand but felt in my core.

"You like that?" Max asked, looking up at me from between my legs. "You like having my tongue on your pussy?"

"Yes," I gasped. "Fuck, yes."

He went back to work, his tongue circling my clit, then dipping inside me. I was already close, the combination of three men touching me, the exhibitionism of it, the pure filth of the situation pushing me toward the edge.

"She's going to come," Kai said, watching my face. "Look at her."

Max sucked my clit hard and I shattered, crying out, my hands fisting in his hair. He didn't stop, working me through it until I was trembling and oversensitive.

"My turn," Kai said, pulling off his shirt. The others started undressing too, and I watched through heavy-lidded eyes as they revealed their bodies—all lean muscle and tattoos and piercings.

Kai pulled a condom from his jeans pocket, rolled it on. His cock was thick and hard, and I felt a flutter of nervousness mixed with anticipation. He positioned himself between my legs, the head of his cock pressing against my entrance.

"Ready?" he asked.

"Yes. Fuck me."

He pushed in slowly, stretching me, filling me. I moaned, wrapping my legs around his waist, pulling him deeper. He started to move, slow at first, then faster, harder, until the bed was creaking beneath us.

Jonas moved to the head of the bed, his cock in his hand. "Open your mouth," he said.

I did, and he guided himself between my lips. I sucked him while Kai fucked me, the dual sensation overwhelming. Jonas was thick, hitting the back of my throat, and I gagged slightly but didn't pull away.

"Fuck, that's good," Jonas groaned, his hand in my hair, guiding my movements.

Kai's rhythm was relentless, each thrust hitting deep, and I felt another orgasm building. He reached between us, his thumb finding my clit, rubbing in circles, and I came again, moaning around Jonas's cock.

"Shit, I'm close," Kai said, his movements becoming erratic. He thrust deep one last time and came with a groan, his body shuddering.

He pulled out and Max immediately took his place, already wearing a condom. He flipped me over onto my hands and knees, positioning himself behind me. His cock was longer than Kai's, and when he pushed in, I felt it everywhere.

"Fuck," I moaned, dropping to my elbows.

Max grabbed my hips, pulling me back onto him with each thrust. The angle was different, deeper, hitting spots that made me see stars. Jonas was still in front of me, and I took him back in my mouth, sucking hard, using my hand on what wouldn't fit.

"Such a good little groupie," Max said, smacking my ass. The sting made me moan. "Taking all of us. You love this, don't you?"

"Yes," I gasped when Jonas pulled out for a moment. "I love it."

Max fucked me harder, the sound of skin slapping against skin filling the room. I could feel another orgasm building, the intensity almost too much. When he reached around to play with my clit, I came so hard I nearly collapsed, only Max's grip on my hips keeping me upright.

"Fuck, I'm going to come," Jonas said, his hand tightening in my hair. "Swallow it."

He came in my mouth and I did as he said, swallowing, tasting him. He pulled out and I gasped for air, my body still shaking from my own orgasm.

Max pulled out and I collapsed onto the bed, completely spent. But they weren't done.

"Come here," Kai said, pulling me into his lap on the couch. He was hard again, a new condom already on. "Ride me."

I straddled him, sinking down onto his cock with a moan. My legs were shaking but I started to move, rolling my hips, finding a rhythm. Jonas and Max watched, stroking themselves, and the exhibitionism of it sent another thrill through me.

Kai's hands were on my ass, guiding my movements, pulling me down harder. "That's it," he said. "Fuck yourself on my cock."

I rode him faster, chasing another orgasm even though I didn't think I had another one in me. But when Max moved behind me, his fingers finding my ass, pressing gently, I gasped.

"Ever done anal?" he asked.

"No," I admitted.

"Want to try? We'll be gentle."

I should have said no. Should have drawn a line. But I was so far gone, so lost in the pleasure and the moment.

"Okay," I whispered.

Max used lube from somewhere, working me open slowly with his fingers while I continued to ride Kai. It was strange at first, uncomfortable, but then it started to feel good. Really good.

"Ready?" Max asked, and I nodded.

He pressed in slowly, so slowly, and the feeling of being filled in both places was indescribable. I'd never felt so full, so completely overwhelmed.

"Fuck," I moaned. "Oh my god."

They moved together, finding a rhythm, and I was completely at their mercy. Jonas stood beside us, stroking himself, and when he came on my breasts, I came too, the most intense orgasm yet, my whole body convulsing.

Kai and Max followed soon after, and then we all collapsed in a heap, sweaty and exhausted and completely satisfied.

We stayed like that for a while, catching our breath. Someone brought water and we drank, and then we started again, slower this time, more deliberate. They took turns with me, sometimes one at a time, sometimes two, exploring every combination, every position.

By the time the sun started to rise, I was sore and exhausted and marked with hickeys and fingerprint bruises. They were gentle with me afterward, helping me get dressed, making sure I was okay, calling me a cab.

"You were incredible," Kai said, kissing my forehead. "Really. Thank you."

"Will I see you again?" I asked, even though I knew the answer.

"We leave for Amsterdam tomorrow. But maybe. If you want to follow us."

I didn't follow them to Amsterdam. I went home to my tiny apartment in Neukölln, took a long shower, and slept for twelve hours. When I woke up, I was sore everywhere, and I had bruises on my hips and thighs and ass.

I should have felt used. Should have felt cheap. But I didn't. I felt powerful. I'd wanted something and I'd taken it. I'd lived out a fantasy that most people only dream about. I'd been brave and reckless and completely myself.

The band did break big, like everyone said they would. I see them on magazine covers sometimes, playing festivals, living the rock star life. I wonder if they remember me, if I was just one of many or if I stood out somehow.

It doesn't really matter. Because that night in Berlin wasn't about them—it was about me. About claiming my sexuality, my agency, my right to pleasure on my own terms. About being the kind of woman who goes backstage and says yes to everything.

And I'd do it again in a heartbeat.`
};
